import styled from "@emotion/styled/macro";

export const BulkTagEditorContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const TagSection = styled.div``;

export const TagSectionTitle = styled.h4`
    margin: 0 0 8px 0;
    font-size: 14px;
    font-weight: 500;
    color: #1A1B1D;
`;

export const CreateTagInputContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 8px 0 16px;
    border: 1px solid #585D66;
    border-radius: 12px;
    height: 48px;
    position: relative;
`;

export const CreateTagIcon = styled.div`
    color: #1A1B1D;
`;

export const CreateTagInput = styled.input`
    border: none;
    outline: none;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    flex: 1;
    background: transparent;
    &::placeholder {
        color: #9097A3;
    }
`;

export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const SelectedTagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const AvailableTagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 200px;
    overflow-y: auto;
`;

export const TagItem = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px 6px 10px;
    background-color: ${props => props.isSelected ? '#1A1B1D' : '#F1F3F5'};
    color: ${props => props.isSelected ? 'white' : '#1A1B1D'};
    border-radius: 37px;
    cursor: pointer;
    font-size: 14px;
    border: none;
    font-family: Circular;
    font-weight: 450;
`;

export const TagCheckmark = styled.span`
    margin-left: 4px;
`;

export const PlusIcon = styled.div`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;